// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__16g13","title":"InfoRow_title__2f-MV"};